import store from '@/store'
import router from '@/router'
import axios from 'axios'
import { HTTP_STATUS, HTTP_HEADER_SKIP_ERROR } from '@/libs/constants'
import { getAuthToken, removeAuthData } from '@/libs/auth-helper'
import { baseUrl, isApiUrl } from '@/libs/api-request'

const httpClient = axios.create({
  baseURL: baseUrl()
})

httpClient.interceptors.request.use(function (config) {
  if (isApiUrl(config.url)) {
    if (config.data && typeof config.data === 'object' && !config.data['serviceType']) {
      config.data['serviceType'] = 'ut'
    }

    if (config.method === 'get') {
      if (!config.params) {
        config.params = {}
      }
      config.params.t = new Date().getTime()
    }

    const authToken = getAuthToken()

    if (authToken) {
      config.headers = Object.assign(config.headers, {
        Authorization: `Bearer ${authToken.accessToken}`
      })
    }
  }
  return config
}, function (error) {
  return Promise.reject(error)
})

httpClient.interceptors.response.use(function (response) {
  if (isApiUrl(response.config.url) && !response.data.success) {
    const message = response.data.message || 'RESPONSE_FAILED'
    const error = new Error(message)
    error.isFailed = true
    return Promise.reject(error)
  } else {
    return response
  }
}, function (error) {
  let needAlert = true
  if (error.config.headers[HTTP_HEADER_SKIP_ERROR]) {
    needAlert = false
  } else if (error.response && error.response.status) {
    const statusCode = error.response.status

    const authFailedStatusCodes = [
      HTTP_STATUS.unauthrized,
      HTTP_STATUS.unprocessableEntity
    ]
    if (authFailedStatusCodes.includes(statusCode)) {
      needAlert = false
      if (window.__VUE_ROOT__) {
        window.__VUE_ROOT__.$children[0].signOut()
      } else {
        removeAuthData()
      }
      if (!error.config.allowNoAuth) {
        router.push({ name: 'sign-in' })
      }
    } else if (statusCode === HTTP_STATUS.badRequest) {
      // to-do: what happened?
    }
  }

  if (needAlert) {
    error.isHandled = true
    store.commit('setErrorData', { code: 500, error })
  }
  return Promise.reject(error)
})

export default httpClient
